var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isClienti)?_c('drawer-clienti'):_vm._e(),(_vm.isRivenditori)?_c('drawer-rivenditori'):_vm._e(),(_vm.isService)?_c('drawer-service'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }